import { useEffect, useState } from 'react';
import axios from 'axios';
import { useFilters } from './FilterContext';
import config from '../config/config';

export function useFilterFetch({ onStart, onComplete }) {
    const { filters } = useFilters();
    const [estates, setEstates] = useState([]);

    useEffect(() => {
        const fetchEstates = async () => {
            if (onStart) onStart();
            try {
                const response = await axios.get(`${config.apiUrl}/api/estates`, {
                    params: {
                        minPrice: filters.price[0],
                        maxPrice: filters.price[1],
                        location: filters.location,
                        locationRadius: filters.locationRadius,
                        minBedrooms: filters.bedrooms[0],
                        maxBedrooms: filters.bedrooms[1],
                        minBathrooms: filters.bathrooms[0],
                        maxBathrooms: filters.bathrooms[1],
                        propertyType: filters.propertyType,
                        propertySubtype: filters.propertySubtype,
                        minLotSize: filters.lotSize[0],
                        maxLotSize: filters.lotSize[1],
                        minLivingSpace: filters.livingSpace[0],
                        maxLivingSpace: filters.livingSpace[1],
                        minBuildYear: filters.buildYear[0],
                        maxBuildYear: filters.buildYear[1],
                        offer_type: filters.offer_type,
                    },
                });
                setEstates(response.data.data);
                console.log("Fetched estates:", response.data.data);
            } catch (error) {
                console.error("Error fetching estates:", error);
            } finally {
                if (onComplete) onComplete();
            }
        };

        fetchEstates();
    }, [
        filters.price, filters.location, filters.locationRadius, filters.bedrooms,
        filters.bathrooms, filters.propertyType, filters.propertySubtype,
        filters.lotSize, filters.livingSpace, filters.buildYear, filters.offer_type
    ]);

    useEffect(() => {
        const params = new URLSearchParams();
        params.set('minPrice', filters.price[0]);
        params.set('maxPrice', filters.price[1]);
        if (filters.location) params.set('location', filters.location);
        if (filters.locationRadius) params.set('locationRadius', filters.locationRadius);
        if (filters.bedrooms) {
            params.set('minBedrooms', filters.bedrooms[0]);
            params.set('maxBedrooms', filters.bedrooms[1]);
        }
        if (filters.bathrooms) {
            params.set('minBathrooms', filters.bathrooms[0]);
            params.set('maxBathrooms', filters.bathrooms[1]);
        }
        if (filters.propertyType) params.set('propertyType', filters.propertyType);
        if (filters.propertySubtype) params.set('propertySubtype', filters.propertySubtype);
        if (filters.lotSize) {
            params.set('minLotSize', filters.lotSize[0]);
            params.set('maxLotSize', filters.lotSize[1]);
        }
        if (filters.livingSpace) {
            params.set('minLivingSpace', filters.livingSpace[0]);
            params.set('maxLivingSpace', filters.livingSpace[1]);
        }
        if (filters.buildYear) {
            params.set('minBuildYear', filters.buildYear[0]);
            params.set('maxBuildYear', filters.buildYear[1]);
        }
        if (filters.offer_type) params.set('offer_type', filters.offer_type);

        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }, [
        filters.price, filters.location, filters.locationRadius, filters.bedrooms,
        filters.bathrooms, filters.propertyType, filters.propertySubtype,
        filters.lotSize, filters.livingSpace, filters.buildYear, filters.offer_type
    ]);

    return estates;
}
